import { render, staticRenderFns } from "./DomainDetailsModal.vue?vue&type=template&id=240fa433&scoped=true"
import script from "./DomainDetailsModal.vue?vue&type=script&lang=js"
export * from "./DomainDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240fa433",
  null
  
)

export default component.exports